"use client"

import { Toaster } from '@/components/ui/sonner';

export default function StaffLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  // AppProvider is now provided by RootLayout, no need to duplicate it here
  return (
    <>
      {children}
      <Toaster />
    </>
  );
}
